/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:75e9196a-fd71-476d-a7e6-50c4322f529b",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_EVZDZQ1ZB",
    "aws_user_pools_web_client_id": "19jcl0ppet56rkh10vk6ss9h6",
    "oauth": {
        "domain": "auth.quizwizard.net",      
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://quizwizard.net/practiceevents",
        "redirectSignOut": "https://quizwizard.net",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS"
};


export default awsmobile;
